import React, { useState, useEffect } from 'react';
import PhoneInput from '../UIKits/PhoneInput';
import DatePicker from 'react-datepicker';
import AsyncSelect from 'react-select/async/dist/react-select.esm';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Switch from 'react-switch';
import waiting from '../../assets/images/waiting.gif';
import {
	genders,
	maritalStatuses,
	ethnicities,
	hmoAPI,
	relationships,
	searchAPI,
	serviceAPI,
	patientAPI,
	API_URI,
} from '../../services/constants';
import {
	request,
	staffname,
	Compulsory,
	patientname,
	camelCaseToSentenceCase,
	validateEmail,
	validatePhone,
	getFormattedGender,
	parseDojahAvatar,
	parseAvatar,
	upload as uploadRequest,
} from '../../services/utilities';
import { startBlock, stopBlock } from '../../actions/redux-block';
import { notifyError, notifySuccess } from '../../services/notify';
import { messageService } from '../../services/message';
import { setPatientRecord } from '../../actions/user';
import startCase from 'lodash.startcase';
import { isValid } from 'date-fns';

const initialData = {
	surname: '',
	other_names: '',
	email: '',
	date_of_birth: '',
	gender: '',
	maritalStatus: '',
	hmo_id: '',
	address: '',
	phone_number: '',
	ethnicity: '',
	occupation: '',
	enrollee_id: '',
	is_staff: false,
	staff_id: '',
	nok_surname: '',
	nok_other_names: '',
	nok_date_of_birth: '',
	nok_gender: '',
	nok_maritalStatus: '',
	nok_occupation: '',
	nok_ethnicity: '',
	nok_relationship: '',
	nok_address: '',
	nok_phoneNumber: '',
	nok_email: '',
	is_mother: false,
	mother_id: '',
};

const PatientForm = ({ patient, closeModal, history, location, isEnroll = false, fetchPatients = null }) => {
	const path = location.pathname.split('/');

	const temporaryImage = require('../../assets/images/placeholder.jpg');

	const [patientImg, setPatientImg] = useState(temporaryImage);
	const [upload, setupload] = useState(false);
	const [loaded, setLoaded] = useState(false);
	const [hmo, setHmo] = useState(null);
	// const [dateOfBirth, setDateOfBirth] = useState(null);
	// const [nokDateOfBirth, setNokDateOfBirth] = useState(null);
	const [staff, setStaff] = useState(null);
	const [mother, setMother] = useState(null);
	const [signatureRawData, setSignatureRawData] = useState('');
	const [signatureImageData, setSignatureImageData] = useState('');
	const [imgHeight, setImgHeight] = useState(0);
	const [imgWidth, setImgWidth] = useState(0);
	const [isUpdated, setIsupdated] = useState(false);
	const [services, setServices] = useState([]);
	const [serviceId, setServiceId] = useState(undefined);
	const [searchType, setSearchType] = useState('phone');
	const [searchValue, setSearchValue] = useState('');
	const [currentStep, setCurrentStep] = useState(1);
	const [autoFill, setAutoFill] = useState(false);
	const [disabledArr, setDisabledArr] = useState([]);
	const [error, setError] = useState('');
	const [data, setData] = useState(initialData);

	const dispatch = useDispatch();

	const getRegServices = async () => {
		const url = `${serviceAPI}/registration`;
		const result = await request(url, 'GET', true);
		setServices(result);
		setServiceId(result[0]?.id);
	};

	const profileImageUpload = async e => {
		e.preventDefault();
		const file = e.target.files[0];
		if (file) {
			setupload(true);
			try {
				let formData = new FormData();
				formData.append('file', file);
				const url = `${API_URI}/${patientAPI}/upload-avatar`;
				const rs = await uploadRequest(url, 'POST', formData);
				setPatientImg(parseAvatar(rs.link));
				setupload(false);
			} catch (error) {
				setupload(false);
				console.log(error);
				dispatch(stopBlock());
				notifyError(e.message || 'could not upload data');
			}
		}
	};

	const getHmoSchemes = async q => {
		if (!q || q.length <= 1) {
			return [];
		}

		const url = `${hmoAPI}/schemes?q=${q}`;
		const { result } = await request(url, 'GET', true);
		return result;
	};

	const getStaffs = async q => {
		if (!q || q.length <= 1) {
			return [];
		}

		const url = `hr/staffs/find?q=${q}`;
		const result = await request(url, 'GET', true);
		return result;
	};

	const getPatients = async q => {
		if (!q || q.length < 1) {
			return [];
		}

		const url = `${searchAPI}?q=${q}&isQuickSearch=1`;
		const res = await request(url, 'GET', true);
		return res;
	};

	const getFemalePatients = async q => {
		if (!q || q.length < 1) {
			return [];
		}

		const url = `${searchAPI}?q=${q}&isQuickSearch=1&gender=female`;
		const res = await request(url, 'GET', true);
		return res;
	};

	const getInitialValues = patient => {
		console.log('patient', patient);
		if (patient) {
			return {
				surname: patient.surname || '',
				other_names: patient.other_names || '',
				email: patient.email || '',
				date_of_birth: patient.date_of_birth ? moment(patient.date_of_birth, 'YYYY-MM-DD').format('YYYY-MM-DD') : '',
				gender: getFormattedGender(patient.gender),
				maritalStatus: patient.maritalStatus || '',
				hmo_id: patient.hmo?.id || '',
				enrollee_id: patient.enrollee_id || '',
				occupation: patient.occupation || '',
				address: patient.address || '',
				phone_number: patient.phone_number || '',
				ethnicity: patient.ethnicity || '',
				nok_surname: patient?.nextOfKin?.surname || '',
				nok_other_names: patient?.nextOfKin?.other_names || '',
				nok_date_of_birth: patient?.nextOfKin?.date_of_birth
					? moment(patient.nextOfKin.date_of_birth, 'YYYY-MM-DD').format('YYYY-MM-DD')
					: '',
				nok_gender: getFormattedGender(patient?.nextOfKin?.gender),
				nok_maritalStatus: patient?.nextOfKin?.maritalStatus || '',
				nok_occupation: patient.nextOfKin?.occupation || '',
				nok_ethnicity: patient?.nextOfKin?.ethnicity || '',
				nok_relationship: patient?.nextOfKin?.relationship || '',
				nok_address: patient?.nextOfKin?.address || '',
				nok_phoneNumber: patient?.nextOfKin?.phoneNumber || '',
				nok_email: patient?.nextOfKin?.email || '',
				is_staff: patient?.staff ? true : false,
				is_mother: patient?.mother ? true : false,
				staff_id: patient?.staff?.id || null,
				mother_id: patient?.mother_id,
				is_verified: patient?.is_verified,
			};
		} else {
			return initialData;
		}
	};

	const OnLoadSetValue = async () => {
		const patientsig = `patient/signature/get/?id=${patient?.signature_id || ''}&type=patient`;

		if (!isUpdated) {
			const { signature } = await request(patientsig, 'GET', true);

			// setSignatureImageData(signature?.signature);
			setIsupdated(true);

			// TODO: show me big

			const ctx = document.getElementById('cvs')?.getContext('2d');

			const img = new Image();
			img.onload = function () {
				ctx.drawImage(img, 0, 0, 500, 150);
			};

			img.src = 'data:image/png;base64,' + signature?.signature;
			console.log('loaded for on load');
		}
	};

	useEffect(() => {
		if (!loaded) {
			if (patient) {
				if (patient.date_of_birth && !moment(new Date(patient.date_of_birth)).isValid()) {
					setData({ ...data, date_of_birth: '' });
				}
				if (patient?.nextOfKin?.date_of_birth && !moment(new Date(patient.nextOfKin.date_of_birth)).isValid()) {
					setData({ ...data, nok_date_of_birth: '' });
				}
				if (patient?.staff) {
					setStaff(patient.staff);
				} else {
					setStaff(null);
				}
				setHmo(patient?.hmo);
				if (patient?.mother) {
					setMother(patient.mother);
				} else {
					setMother(null);
				}
				if (patient.profile_pic && patient.profile_pic.trim() !== '') {
					setPatientImg(parseAvatar(patient.profile_pic));
				} else {
					setPatientImg(temporaryImage);
				}
			}
			setLoaded(true);
			setIsupdated(false);
			getRegServices();
		}
	}, [loaded, patient]);

	const checkIsVerified = vals => {
		let isVerified = false;
		if (patient) {
			if (vals?.surname !== patient.surname) {
				isVerified = false;
			} else if (vals?.other_names !== patient.other_names) {
				isVerified = false;
			} else if (vals?.gender?.toLowerCase() !== patient.gender?.toLowerCase()) {
				isVerified = false;
			} else if (vals?.phone_number !== patient.phone_number) {
				isVerified = false;
			} else if (
				moment(new Date(vals.date_of_birth)).format('YYYY-MM-DD') !== moment(new Date(patient.date_of_birth)).format('YYYY-MM-DD')
			) {
				isVerified = false;
			} else {
				isVerified = patient?.is_verified;
			}
		} else {
			if (disabledArr.length > 0) {
				isVerified = true;
			}
		}
		return isVerified;
	};

	const onSubmit = async values => {
		const isVerified = checkIsVerified(values);
		const data = {
			...values,
			avatar: patientImg === temporaryImage ? null : patientImg,
			enrollee_id: values.enrollee_id || null,
			sign: signatureImageData,
			service_id: serviceId,
			hmo_id: hmo?.id || values.hmo_id,
			staff_id: staff?.id || values.staff_id,
			mother_id: mother?.id || values.mother_id,
			is_verified: isVerified,
			nin: disabledArr.length && searchType === 'nin' ? searchValue : patient?.nin || null,
		};

		if (!patient) {
			try {
				dispatch(startBlock());
				const rs = await request('patient', 'POST', true, { ...data, service_id: serviceId });
				dispatch(stopBlock());
				if (rs.success) {
					notifySuccess('Patient account created!');
					if (path[1] === 'front-desk') {
						history.push('/front-desk/patients');
					} else {
						messageService.sendMessage({
							type: 'new-patient',
							data: rs.patient,
						});
					}
					closeModal();
				} else {
					setError(rs.message || 'Could not save patient record');
					return;
				}
			} catch (e) {
				console.log(e.message);
				dispatch(stopBlock());
				setError('could not save patient record');
			}
		} else {
			try {
				dispatch(startBlock());
				const url = `patient/${patient.id}?enroll=${isEnroll ? 1 : 0}`;
				const rs = await request(url, 'PUT', true, data);
				dispatch(stopBlock());
				if (rs.success) {
					dispatch(setPatientRecord({ ...patient, ...rs.patient }));
					if (path === 'patients') {
						messageService.sendMessage({
							type: 'update-patient',
							data: rs.patient,
						});
					} else {
						if (fetchPatients !== null) {
							fetchPatients(1, '');
						}
					}
					notifySuccess('Patient account saved!');
					closeModal();
				} else {
					setError(rs.message || 'Could not save patient record');
					return;
				}
			} catch (e) {
				console.log(e.message);
				dispatch(stopBlock());
				setError('could not save patient record');
			}
		}
	};

	const handleChange = e => {
		const { name, value, type, checked } = e.target;
		setData(prev => ({
			...prev,
			[name]: type === 'checkbox' ? checked : value,
		}));
	};

	const startSigning = () => {
		const canvasObj = document.getElementById('cvs');
		canvasObj.getContext('2d').clearRect(0, 0, canvasObj.width, canvasObj.height);
		setImgWidth(canvasObj.width);
		setImgHeight(canvasObj.height);

		const message = {
			firstName: '',
			lastName: '',
			eMail: '',
			location: '',
			imageFormat: 1,
			imageX: imgWidth,
			imageY: imgHeight,
			imageTransparency: false,
			imageScaling: false,
			maxUpScalePercent: 0.0,
			rawDataFormat: 'ENC',
			minSigPoints: 25,
		};

		document.addEventListener('SigCaptureWeb_SignResponse', SignResponse, false);
		const messageData = JSON.stringify(message);
		const element = document.createElement('SigCaptureWeb_ExtnDataElem');
		element.setAttribute('SigCaptureWeb_MsgAttribute', messageData);
		document.documentElement.appendChild(element);
		const evt = document.createEvent('Events');
		evt.initEvent('SigCaptureWeb_SignStartEvent', true, false);
		element.dispatchEvent(evt);
	};

	const SignResponse = event => {
		const str = event.target.getAttribute('SigCaptureWeb_msgAttri');
		const obj = JSON.parse(str);
		SetValues(obj, imgWidth, imgHeight);
	};

	const SetValues = (objResponse, imageWidth, imageHeight) => {
		const obj = JSON.parse(JSON.stringify(objResponse));
		const ctx = document.getElementById('cvs').getContext('2d');

		if (obj.errorMsg !== null && obj.errorMsg !== '' && obj.errorMsg !== 'undefined') {
			alert(obj.errorMsg);
		} else {
			if (obj.isSigned) {
				setSignatureImageData(obj.imageData);
				setSignatureRawData(obj.rawData);

				const img = new Image();
				img.onload = function () {
					ctx.drawImage(img, 0, 0, imageWidth, imageHeight);
				};
				img.src = 'data:image/png;base64,' + obj.imageData;
			}
		}
	};

	const ClearFormData = () => {
		setSignatureImageData('');
		setSignatureRawData('');
	};

	const searchData = async () => {
		try {
			dispatch(startBlock());
			if (!searchValue || searchValue.length < 5) {
				dispatch(stopBlock());
				return notifyError('Search value should be at least 5 chars');
			}
			const url = 'patient/look-up/dojah';
			const res = await request(url, 'POST', true, { [searchType]: searchValue });
			if (res.success) {
				dispatch(stopBlock());
				setData({
					...initialData,
					date_of_birth: isValid(res.data.date_of_birth) ? moment(res.data.date_of_birth, 'YYYY-MM-DD').toDate() : '',
					nok_date_of_birth: isValid(res.data.nok_date_of_birth) ? moment(res.data.nok_date_of_birth, 'YYYY-MM-DD').toDate() : '',
					...res.data,
				});

				if (res.data.profile_pic) {
					setPatientImg(parseDojahAvatar(res.data.profile_pic));
					setupload(false);
				}

				setDisabledArr(Object.keys(res.data));
			} else {
				dispatch(stopBlock());
				notifyError(res?.message || 'Error fetching data');
			}
		} catch (error) {
			dispatch(stopBlock());
			console.log(error);
			notifyError(error?.message || 'Error fetching data');
		}
	};

	useEffect(() => {
		if (patient) {
			const newData = getInitialValues(patient);
			setData({
				...newData,
				hmo_id: patient.hmo?.id || hmo?.id || '',
				staff_id: patient.staff?.id || staff?.id || '',
				mother_id: patient.mother?.id || mother?.id || '',
			});
		}
	}, [patient]);

	const stepValidated = step => {
		const requiredInStepOne = [
			'surname',
			'other_names',
			'email',
			'date_of_birth',
			'gender',
			'maritalStatus',
			'hmo_id',
			'address',
			'phone_number',
			'ethnicity',
		];
		const requiredInStepTwo = ['nok_surname', 'nok_other_names', 'nok_gender', 'nok_address', 'nok_phoneNumber', 'nok_ethnicity'];
		switch (step) {
			case 1:
				for (const item of requiredInStepOne) {
					if (!data[item]) {
						return `${startCase(camelCaseToSentenceCase(item))} is required`;
					}
					if (item === 'email' && !validateEmail(data.email)) {
						return 'Invalid email address';
					}
					if (item === 'phone_number' && !validatePhone(data.phone_number)) {
						return 'Invalid mobile number';
					}
				}
				break;
			case 2:
				for (const item of requiredInStepTwo) {
					if (!data[item]) {
						return `${startCase(camelCaseToSentenceCase(item))} is required`;
					}
				}
				break;

			default:
				return 'Step not valid';
		}
		return true;
	};

	useEffect(() => {
		setError('');
		if (!data.hmo_id) {
			if (!hmo) {
				setHmo(null);
			} else {
				setData({ ...data, hmo_id: hmo.id });
			}
		}
		if (!data.staff_id) {
			if (!staff) {
				setStaff(null);
			} else {
				setData({ ...data, staff_id: staff.id });
			}
		}
		if (!data.mother_id) {
			if (!mother) {
				setMother(null);
			} else {
				setData({ ...data, mother_id: mother.id });
			}
		}
	}, [data, hmo, staff, mother]);

	return (
		<div className="onboarding-modal modal fade animated show" role="dialog" style={{ display: 'block' }}>
			<div className="modal-dialog modal-lg" style={{ maxWidth: '1024px' }}>
				<div className="modal-content text-center">
					<div className="modal-header faded smaller">
						<div className="modal-title text-center">
							{patient ? 'Edit Patient Record' : 'New Patient Registration'} - Step {currentStep} -{' '}
							{currentStep === 1 ? 'Personal Information' : currentStep === 2 ? 'Next Of Kin Information' : 'Signature Pad'}
						</div>
						<button aria-label="Close" className="close" type="button" onClick={closeModal}>
							<span className="os-icon os-icon-close" />
						</button>
					</div>
					<div className="onboarding-content with-gradient">
						<div className="modal-body">
							{error && (
								<div
									className="alert alert-danger"
									dangerouslySetInnerHTML={{
										__html: `<strong>Error!</strong> ${error}`,
									}}
								/>
							)}
							<div className="support-index">
								<div className="support-ticket-content-w">
									<div
										className="support-ticket-info"
										// style={{ flex: '0 0 200px' }}
										style={{ display: 'flex', flexDirection: 'column' }}
									>
										<div className="customer mb-0 pb-0" style={{ width: '100%', borderBottom: '0 none', height: '200px' }}>
											<div
												className="avatar"
												style={{
													width: '100%',
													margin: 'auto',
												}}
											>
												<img alt="" style={{ width: '180px' }} src={patientImg} />
											</div>
										</div>
										<div className="mt-5 text-center d-flex justify-content-center flex-column align-items-center">
											<input hidden type="file" id="my-file" onChange={profileImageUpload} />
											<label className="btn btn-info btn-small text-white w-100" htmlFor="my-file">
												{upload ? (
													<>
														<img src={waiting} alt="submitting" />
														Uploading ...
													</>
												) : (
													<>
														<i className="os-icon os-icon-ui-51" />
														Upload picture
													</>
												)}
											</label>
											<label className="btn btn-primary btn-small mt-2 mx-0 w-100">
												<>
													<i className="os-icon os-icon-ui-65" /> take photo
												</>
											</label>
										</div>
									</div>
								</div>
								<div
									className=""
									style={{
										width: 'calc(100% - 240px)',
										marginLeft: '20px',
									}}
								>
									<form
										onSubmit={e => {
											e.preventDefault();
										}}
									>
										{/* Auto Fill Section */}
										<div className="row">
											<div className="col-sm">
												<div className="element-wrapper">
													<div
														className="element-actions mb-3"
														style={{
															display: 'flex',
															justifyContent: 'space-evenly',
															alignItems: 'center',
														}}
													>
														<Switch
															onChange={e => {
																if (autoFill) {
																	setDisabledArr([]);
																	setSearchValue('');
																}
																setAutoFill(!autoFill);
															}}
															checked={autoFill}
															height={16}
															width={40}
															onColor="#047bf8"
															className="mr-1"
														/>
														<span>Auto Fill</span>
													</div>

													{autoFill && (
														<div className="col-md-12">
															<div className="element-content">
																<div>
																	<div className="input-group mb-2 mr-sm-2 mb-sm-0">
																		<div className="input-group-prepend">
																			<select
																				name="search_type"
																				className="form-control"
																				placeholder="ID Type"
																				value={searchType}
																				disabled={disabledArr.length}
																				onChange={e => setSearchType(e.target.value)}
																			>
																				<option value="phone">Phone</option>
																				<option value="nin">NIN</option>
																				<option value="online_code">Online Code</option>
																				{/* <option value="bvn">BVN</option> */}
																				{/* <option value="license_number">Drivers License</option> */}
																			</select>
																			<div className="input-group-text ml-1">
																				{searchType === 'nin' ? (
																					<div className="fa fa-id-badge"></div>
																				) : searchType === 'bvn' ? (
																					<div className="fa fa-bank"></div>
																				) : (
																					<div className="os-icon os-icon-phone"></div>
																				)}
																			</div>
																		</div>
																		<input
																			className="form-control"
																			placeholder={
																				searchType === 'nin'
																					? '70123456789'
																					: searchType === 'bvn'
																					? '22222222222'
																					: searchType === 'license_number'
																					? 'FKJ49409AB13'
																					: searchType === 'online_code'
																					? 'REG12345678'
																					: '09011111111'
																			}
																			value={searchValue}
																			readOnly={disabledArr.length}
																			onChange={e => {
																				setSearchValue(e.target.value);
																			}}
																		/>
																		<button
																			type="button"
																			disabled={!searchType}
																			className="btn btn-primary ml-1"
																			onClick={() => {
																				if (disabledArr?.length) {
																					setDisabledArr([]);
																					setSearchValue('');
																				} else {
																					searchData();
																				}
																			}}
																		>
																			{disabledArr.length ? <i className="fa fa-close" /> : <i className="os-icon os-icon-ui-37" />}
																		</button>
																	</div>
																</div>
															</div>
														</div>
													)}
													{!autoFill && patient?.is_verified && (
														<div className="col-md-12">
															<div className="element-content">
																<div>
																	<div className="input-group mb-2 mr-sm-2 mb-sm-0">
																		<div className="input-group-prepend">
																			<select
																				name="search_type"
																				className="form-control"
																				placeholder="ID Type"
																				value={patient?.nin ? 'nin' : 'phone'}
																				disabled={true}
																			>
																				<option value="phone">Phone</option>
																				<option value="nin">NIN</option>
																			</select>
																			<div className="input-group-text ml-1">
																				{patient?.nin ? (
																					<div className="fa fa-id-badge"></div>
																				) : (
																					<div className="os-icon os-icon-phone"></div>
																				)}
																			</div>
																		</div>
																		<input className="form-control" value={patient?.nin || patient?.phone_number} readOnly={true} />
																		<button
																			type="button"
																			disabled={true}
																			className="btn btn-primary ml-1"
																			onClick={() => {
																				if (disabledArr?.length) {
																					setDisabledArr([]);
																					setSearchValue('');
																				} else {
																					searchData();
																				}
																			}}
																		>
																			{disabledArr.length ? <i className="fa fa-close" /> : <i className="os-icon os-icon-ui-37" />}
																		</button>
																	</div>
																</div>
															</div>
														</div>
													)}
												</div>
											</div>
										</div>

										{/* Step 1: Personal Information */}
										{currentStep === 1 && (
											<>
												{!patient && (
													<div className="row">
														<div className="col-sm-6">
															<label>Registration Service</label>
															<select
																name="service_id"
																className="form-control"
																placeholder="Select Registration Service"
																value={serviceId}
																onChange={e => {
																	setServiceId(e.target.value);
																}}
															>
																{services?.map((item, i) => (
																	<option key={i} value={item.id}>
																		{item?.name}
																	</option>
																))}
															</select>
														</div>
													</div>
												)}

												<div className="row mt-3">
													<div className="col-sm">
														<div className="form-group">
															<label>
																Surname <Compulsory />
															</label>
															<input
																name="surname"
																className="form-control"
																type="text"
																placeholder="Surname"
																value={data.surname}
																onChange={handleChange}
																readOnly={disabledArr.includes('surname')}
															/>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>
																Other Names <Compulsory />
															</label>
															<input
																name="other_names"
																className="form-control"
																type="text"
																placeholder="Other Names"
																value={data.other_names}
																onChange={handleChange}
																readOnly={disabledArr.includes('other_names')}
															/>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>
																Email <Compulsory />
															</label>
															<input
																name="email"
																className="form-control"
																type="email"
																placeholder="Email e.g example@gmail.com"
																value={data.email}
																onChange={handleChange}
																readOnly={disabledArr.includes('email')}
															/>
														</div>
													</div>
												</div>

												<div className="row">
													<div className="col-sm">
														<div className="form-group">
															<label>
																Date of Birth <Compulsory />
															</label>
															<div className="custom-date-input">
																{disabledArr.includes('date_of_birth') ? (
																	<input name="date_of_birth" className="form-control" type="text" value={data.date_of_birth} readOnly />
																) : (
																	<DatePicker
																		selected={
																			data.date_of_birth && moment(data.date_of_birth).isValid() ? new Date(data.date_of_birth) : null
																		}
																		onChange={date => {
																			setData({ ...data, date_of_birth: moment(date).format('YYYY-MM-DD') });
																		}}
																		value={data.date_of_birth}
																		peekNextMonth
																		showMonthDropdown
																		showYearDropdown
																		dropdownMode="select"
																		dateFormat="dd-MM-yyyy"
																		className="single-daterange form-control"
																		placeholderText="Select date of birth"
																		maxDate={new Date()}
																		name="date_of_birth"
																		disabledKeyboardNavigation
																	/>
																)}
															</div>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>
																Gender <Compulsory />
															</label>
															<select
																name="gender"
																className="form-control"
																value={typeof data.gender === 'object' ? data.gender?.value : data.gender}
																onChange={handleChange}
																readOnly={disabledArr.includes('gender')}
															>
																<option value="">Select Gender</option>
																{genders.map((item, i) => (
																	<option key={i} value={getFormattedGender(item.value)}>
																		{item.label}
																	</option>
																))}
															</select>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>
																Marital Status <Compulsory />
															</label>
															<select
																name="maritalStatus"
																className="form-control"
																value={data.maritalStatus}
																onChange={handleChange}
																readOnly={disabledArr.includes('maritalStatus')}
															>
																<option value="">Select Marital Status</option>
																{maritalStatuses.map((item, i) => (
																	<option key={i} value={item.value}>
																		{item.label}
																	</option>
																))}
															</select>
														</div>
													</div>
												</div>

												<div className="row">
													<div className="col-sm">
														<div className="form-group">
															<label>
																HMO
																<Compulsory />
															</label>
															<AsyncSelect
																isClearable
																getOptionValue={option => option.id}
																getOptionLabel={option => `${option.name} ${option.name !== 'Private' ? option.phone_number || '' : ''}`}
																defaultOptions
																value={hmo}
																loadOptions={getHmoSchemes}
																onChange={e => {
																	setHmo(e);
																}}
																placeholder={patient ? startCase(patient.hmo?.name) : 'Search hmo scheme'}
															/>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>Enrollee ID</label>
															<input
																name="enrollee_id"
																className="form-control"
																type="text"
																placeholder="Enrollee ID"
																value={data.enrollee_id}
																onChange={handleChange}
															/>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>Occupation</label>
															<input
																name="occupation"
																className="form-control"
																type="text"
																placeholder="Occupation"
																value={data.occupation}
																onChange={handleChange}
															/>
														</div>
													</div>
												</div>

												<div className="row">
													<div className="col-sm">
														<div className="form-group">
															<label>
																Address
																<Compulsory />
															</label>
															<input
																name="address"
																className="form-control"
																type="text"
																placeholder="Address"
																value={data.address}
																onChange={handleChange}
																readOnly={disabledArr.includes('address')}
															/>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>
																Mobile Number
																<Compulsory />
															</label>
															<PhoneInput
																name="phone_number"
																value={data.phone_number}
																onChange={handleChange}
																placeholder="Phone Number"
																readOnly={disabledArr.includes('phone_number')}
															/>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>
																Ethnicity
																<Compulsory />
															</label>
															<select name="ethnicity" className="form-control" value={data.ethnicity} onChange={handleChange}>
																{ethnicities.map((item, i) => (
																	<option key={i} value={item.value}>
																		{item.label}
																	</option>
																))}
															</select>
														</div>
													</div>
												</div>

												<div className="row">
													<div className="col-sm-2">
														<div className="form-group">
															<label className="mr-2">Is Staff</label>
															<input name="is_staff" type="checkbox" checked={data.is_staff} onChange={handleChange} />
														</div>
													</div>
													{data.is_staff && (
														<div className="col-sm-10">
															<div className="form-group">
																<label>Staff</label>
																<AsyncSelect
																	isClearable
																	getOptionValue={option => option.id}
																	getOptionLabel={option => staffname(option)}
																	defaultOptions
																	value={staff}
																	loadOptions={getStaffs}
																	onChange={e => {
																		setStaff(e);
																	}}
																	placeholder="Search staff"
																/>
															</div>
														</div>
													)}
												</div>
											</>
										)}

										{/* Step 2: Next of Kin Information */}
										{currentStep === 2 && (
											<>
												<div className="row">
													<div className="col-sm">
														<div className="form-group">
															<label>
																Next of Kin Surname <Compulsory />
															</label>
															<input
																name="nok_surname"
																className="form-control"
																type="text"
																placeholder="NOK Surname"
																value={data.nok_surname}
																onChange={handleChange}
																readOnly={disabledArr.includes('nok_surname')}
															/>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>
																Next of Kin Other Names <Compulsory />
															</label>
															<input
																name="nok_other_names"
																className="form-control"
																type="text"
																placeholder="NOK Other Names"
																value={data.nok_other_names}
																onChange={handleChange}
																readOnly={disabledArr.includes('nok_other_names')}
															/>
														</div>
													</div>
												</div>

												<div className="row">
													<div className="col-sm">
														<div className="form-group">
															<label>Next of Kin Date of Birth</label>
															<div className="custom-date-input">
																{disabledArr.includes('nok_date_of_birth') ? (
																	<input
																		name="nok_date_of_birth"
																		className="form-control"
																		type="text"
																		value={data.nok_date_of_birth}
																		readOnly
																	/>
																) : (
																	<DatePicker
																		selected={
																			data.nok_date_of_birth && moment(data.nok_date_of_birth).isValid()
																				? new Date(data.nok_date_of_birth)
																				: null
																		}
																		onChange={date => {
																			setData({ ...data, nok_date_of_birth: moment(date).format('YYYY-MM-DD') });
																		}}
																		value={data.nok_date_of_birth}
																		peekNextMonth
																		showMonthDropdown
																		showYearDropdown
																		dropdownMode="select"
																		dateFormat="dd-MM-yyyy"
																		className="single-daterange form-control"
																		placeholderText="Select date of birth"
																		maxDate={new Date()}
																		name="nok_date_of_birth"
																		disabledKeyboardNavigation
																		disabled={disabledArr.includes('nok_date_of_birth')}
																	/>
																)}
															</div>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>
																Next of Kin Gender <Compulsory />
															</label>
															<select
																name="nok_gender"
																className="form-control"
																value={typeof data.nok_gender === 'object' ? data.nok_gender.value : data.nok_gender}
																onChange={handleChange}
																readOnly={disabledArr.includes('nok')}
															>
																<option value="">Select Gender</option>
																{genders.map((item, i) => (
																	<option key={i} value={getFormattedGender(item.value)}>
																		{item.label}
																	</option>
																))}
															</select>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>Next of Kin Marital Status</label>
															<select
																name="nok_maritalStatus"
																className="form-control"
																value={data.nok_maritalStatus}
																onChange={handleChange}
															>
																<option value="">Select Marital Status</option>
																{maritalStatuses.map((item, i) => (
																	<option key={i} value={item.value}>
																		{item.label}
																	</option>
																))}
															</select>
														</div>
													</div>
												</div>

												<div className="row">
													<div className="col-sm">
														<div className="form-group">
															<label>Next of Kin Occupation</label>
															<input
																name="nok_occupation"
																className="form-control"
																type="text"
																placeholder="Occupation"
																value={data.nok_occupation}
																onChange={handleChange}
															/>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>
																Next of Kin Ethnicity <Compulsory />
															</label>
															<select
																name="nok_ethnicity"
																className="form-control"
																value={data.nok_ethnicity}
																onChange={handleChange}
																readOnly={disabledArr.includes('nok_ethnicity')}
															>
																{ethnicities.map((item, i) => (
																	<option key={i} value={item.value}>
																		{item.label}
																	</option>
																))}
															</select>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>Relationship to Patient</label>
															<select
																name="nok_relationship"
																className="form-control"
																value={typeof data.nok_relationship === 'object' ? data.nok_relationship.value : data.nok_relationship}
																onChange={handleChange}
															>
																<option value="">Select Relationship</option>
																{relationships.map((item, i) => (
																	<option key={i} value={item.value}>
																		{item.label}
																	</option>
																))}
															</select>
														</div>
													</div>
												</div>

												<div className="row">
													<div className="col-sm">
														<div className="form-group">
															<label>
																Next of Kin Address <Compulsory />
															</label>
															<input
																name="nok_address"
																className="form-control"
																type="text"
																placeholder="Address"
																value={data.nok_address}
																onChange={handleChange}
															/>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>
																Next of Kin Phone Number <Compulsory />
															</label>
															<PhoneInput
																name="nok_phoneNumber"
																value={data.nok_phoneNumber}
																onChange={handleChange}
																placeholder="Phone Number"
															/>
														</div>
													</div>
													<div className="col-sm">
														<div className="form-group">
															<label>Next of Kin Email</label>
															<input
																name="nok_email"
																className="form-control"
																type="email"
																placeholder="Email e.g example@gmail.com"
																value={data.nok_email}
																onChange={handleChange}
															/>
														</div>
													</div>
												</div>

												<div className="row">
													<div className="col-sm-2">
														<div className="form-group">
															<label className="mr-2">Is Mother</label>
															<input name="is_mother" type="checkbox" checked={data.is_mother} onChange={handleChange} />
														</div>
													</div>
													{data.is_mother && (
														<div className="col-sm-10">
															<div className="form-group">
																<label>Mother</label>
																<AsyncSelect
																	isClearable
																	getOptionValue={option => option.id}
																	getOptionLabel={option => patientname(option, true)}
																	defaultOptions
																	value={mother}
																	loadOptions={getFemalePatients}
																	onChange={e => {
																		setMother(e);
																	}}
																	placeholder="Search patient"
																/>
															</div>
														</div>
													)}
												</div>
											</>
										)}

										{/* Step 3: Signature */}
										{currentStep === 3 && (
											<div className="signature-pad-wrapper" onMouseEnter={OnLoadSetValue}>
												<div className="d-flex justify-content-around align-items-center">
													<h2 className="header">Please Sign Here</h2>
													<div>
														<button onClick={startSigning} type="button" className="btn btn-sm btn-primary">
															Click to Sign
														</button>
													</div>
												</div>
												<canvas id="cvs" className="signature-pad" width="500" height="150"></canvas>
											</div>
										)}

										{/* Navigation Buttons */}
										<div className="modal-footer buttons-on-right">
											{currentStep > 1 && (
												<button type="button" className="btn btn-secondary" onClick={() => setCurrentStep(prev => prev - 1)}>
													<i className="os-icon os-icon-arrow-left4" /> Previous
												</button>
											)}
											{currentStep < 3 ? (
												<button
													type="button"
													className="btn btn-primary"
													onClick={() => {
														const isValidStep = stepValidated(currentStep);
														if (isValidStep === true) {
															setError('');
															setAutoFill(false);
															setCurrentStep(prev => prev + 1);
														} else {
															setError(isValidStep);
														}
													}}
												>
													Next <i className="os-icon os-icon-arrow-right4" />
												</button>
											) : (
												<button
													type="button"
													className="btn btn-success"
													onClick={() => {
														onSubmit(data);
													}}
												>
													Submit <i className="fa fa-file" />
												</button>
											)}
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default withRouter(PatientForm);
